import { type RoutePath } from "@-/com.npmjs.expo-router";
import type { MorphemeHrefObject } from "@-/dev.improve.haniverse.lib.morpheme.href.entities";
import { MorphemePanelsContent } from "#morpheme-panels-content";
import {
  type Dispatch,
  type ReactElement,
  type ReactNode,
  type RefObject,
  type SetStateAction,
} from "react";

export interface MorphemePanelsTab {
  render: () => ReactElement;
  route: RoutePath;
  title: string;
}

export type MorphemePanelsActivePanel = "info" | "mnemonics";

export type MorphemePanelsToolbarEditAction = {
  isEditing: boolean;
  onPress: () => void;
} | null;

export type MorphemeMnemonicsViewNavigationResult = {
  pinyin: string | undefined;
};

export type MorphemeMnemonicsViewNavigationRefValue = {
  /**
   * Open the mnemonics tab at `index` (`0` is the meaning tab, `1 + i` the i-th reading) and
   * return its reading; `null` when that tab does not exist or is already open.
   */
  viewPronunciation: (index: number) => MorphemeMnemonicsViewNavigationResult | null;
};

export type MorphemePanelsMnemonicsNavigationProps = {
  activeIndex: number;
  setActiveIndex: Dispatch<SetStateAction<number>>;
  viewNavigationRef: RefObject<MorphemeMnemonicsViewNavigationRefValue | null>;
};

export function MorphemePanels({
  activeIndex,
  activePanel,
  headerExpansionContent,
  morpheme,
  morphemeHrefObject,
  onBack,
  setActiveIndex,
  viewNavigationRef,
}: {
  activePanel: MorphemePanelsActivePanel;
  headerExpansionContent?: ReactNode;
  morpheme: string | string[];
  morphemeHrefObject: MorphemeHrefObject;
  onBack?: () => void;
} & MorphemePanelsMnemonicsNavigationProps) {
  return (
    <MorphemePanelsContent
      activeIndex={activeIndex}
      activePanel={activePanel}
      headerExpansionContent={headerExpansionContent}
      morpheme={morpheme}
      morphemeHrefObject={morphemeHrefObject}
      onBack={onBack}
      setActiveIndex={setActiveIndex}
      viewNavigationRef={viewNavigationRef}
    />
  );
}
